import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

// Assets
import pizzaImage from './assets/pizza.jpg';

// Actions
import { generateCoupon } from '../../../../state/modules/promo/actions';

// Components
import Modal from '../../../../components/Modal';
import MobileModal from '../../../../components/Modal3';
import Button from '../../../../components/Button';

// Styles
import styles from './IdleCodeWidget.styl';

const cx = classNames.bind(styles);

const IdleCodeWidget = () => {
  const intl = useIntl();

  const isAuthenticated = useSelector(state => state.user.isAuthenticated);
  const coupon = useSelector(state => state.promo.coupon);
  const isRealPhone = useSelector(state => state.responsive.isRealPhone);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  // следует ли отключить работу виджета
  const shouldDisableWidget = () => {
    if (typeof window === 'undefined') return false;
    const idleTime = JSON.parse(window.localStorage.getItem('idle_pl')) || 0;
    const dateNow = new Date().getTime();

    return isAuthenticated || idleTime > dateNow;
  };

  // коллбэк при бездействии
  const onIdle = () => {
    if (shouldDisableWidget()) return;
    dispatch(generateCoupon('banner'));
  };

  // настройка бездействия пользователя
  const { pause } = useIdleTimer({
    timeout: 120000,
    stopOnIdle: true,
    crossTab: true,
    onIdle,
  });

  // проверяем нужно ли отключить слежение за бездействием
  useEffect(() => {
    if (shouldDisableWidget()) pause();
  }, []);

  // устанавливаем новое минимальное время срабатывания виджета
  useEffect(() => {
    if (coupon) {
      const dateNow = new Date().getTime();
      window.localStorage.setItem('idle_pl', JSON.stringify(dateNow + 30 * 86400000));
      setShowModal(true);
    }
  }, [coupon]);

  const onCopyHandler = async e => {
    e.stopPropagation();
    await navigator.clipboard.writeText(coupon);
    toast.success(intl.formatMessage({ id: 'promo.popup.copy' }));
  };

  const ModalView = isRealPhone ? MobileModal : Modal;

  if (!showModal || !coupon) return null;

  return (
    <ModalView isOpen={showModal} onClose={() => setShowModal(false)}>
      <div className={cx('IdleCodeWidget', { IdleCodeWidgetMobile: isRealPhone })}>
        {isRealPhone && <div className={cx('IdleCodeWidget__modal-icon')} />}

        <div className={cx('IdleCodeWidget__content')}>
          <div className={cx('IdleCodeWidget__image')}>
            <img src={pizzaImage} alt="image" />
          </div>
          <div className={cx('IdleCodeWidget__text_content')}>
            <p className={cx('IdleCodeWidget__heading')}>
              {intl.formatMessage({ id: 'idleCode.heading' })}
            </p>
            <div className={cx('IdleCodeWidget__discount')}>-20%</div>
            <p className={cx('IdleCodeWidget__text')}>
              {intl.formatMessage({ id: 'idleCode.text' })}
            </p>
            <p className={cx('IdleCodeWidget__code')}>{coupon}</p>
            <Button className={cx('IdleCodeWidget__button')} onClick={onCopyHandler}>
              {intl.formatMessage({ id: 'idleCode.button' })}
            </Button>
          </div>
        </div>

        <div className={cx('IdleCodeWidget__close')} onClick={() => setShowModal(false)} />
      </div>
    </ModalView>
  );
};

export default IdleCodeWidget;
